import { useCallback } from 'react';

import { TaskResponse } from '../client';
import { useTaskCompletedEffect } from './useTaskCompletedEffect';

interface ThrowDiceMiniGame {
  rollingTime: number;
  handleThrow: (score: number) => void;
  remainingScore: number;
  progressPercentage: number;
}

export function useThrowDiceMiniGame(
  task: TaskResponse,
  onTaskStarted: (task: TaskResponse) => Promise<void>,
  onTaskProgress: (task: TaskResponse, progress: number) => void,
  onTaskCompleted: (task: TaskResponse) => Promise<void>,
): ThrowDiceMiniGame {
  useTaskCompletedEffect(task, onTaskCompleted);
  const remainingScore = task.total_effort - task.completed_effort;
  const progressPercentage: number = Math.round((task.completed_effort / task.total_effort) * 100);

  const handleThrow = useCallback(
    (score: number) => {
      if (task.status === 'new') {
        onTaskStarted(task);
      }
      onTaskProgress(task, score);
    },
    [onTaskStarted, onTaskProgress, task],
  );

  return { rollingTime: 1000, handleThrow, remainingScore, progressPercentage };
}
